const theme: any = {
    typography: {
        fontFamily: ['Lato'].join(','),
        htmlFontSize: 16,
        button: {
            textTransform: 'none'
        }
    },
    overrides: {
        MuiButton: {
            label: {
                fontSize: '0.813rem'
            }
        }
    },
    palette: {
        primary: {
            main: '#f36a22',
            contrastText: '#fff'
        },
        secondary: {
            main: '#2991f3',
            light: '#b4e8e9',
            contrastText: '#fff'
        }
    }
};

export default theme;
